enum BlockType {
	DECKBOX = 'DeckBox',
	LANDING = 'Landing',
	STAIR = 'Stair',
	BUMPOUT = 'Bumpout',
}

export default BlockType;
